const state = { periode: {}, dp: {} }
const actions = {
  setDataPerusahaan: ({ commit }, dp) => {
    return new Promise((resolve) => {
      commit("setDataPerusahaan", dp)
      resolve(dp)
    })
  },
  setPeriode: ({ commit }, periode) => {
    return new Promise((resolve) => {
      commit("setPeriode", periode)
      resolve(periode)
    })
  },
  logout: ({ commit }) => {
    return new Promise((resolve) => {
      commit("clearPeriode")
      commit("clearDataPerusahaan")
      resolve()
    })
  },
}
const getters = {
  getPeriode: (state) => state.periode,
  getDataPerusahaan: (state) => state.dp,
}

const mutations = {
  setPeriode: (state, periode) => {
    state.periode = periode
  },
  setDataPerusahaan: (state, dp) => {
    state.dp = dp
  },
  clearDataPerusahaan: (state) => {
    state.dp = {}
  },
  clearPeriode: (state) => {
    state.periode = {}
  },
}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
}
